import * as actionTypes from './actionTypes';
import { ITestDenomination } from '../reducers/testDenominations';

export const addTestDenomination = ( data: ITestDenomination ) => {
    return {
        type: actionTypes.TEST_DENOMINATION_ADD,
        test: data
    };
};

export const removeTestDenominations = ( data: any[] ) => {
  return {
    type: actionTypes.TEST_DENOMINATION_REMOVE,
    test_ids: data
  };
};

export const addMultipleTestDenominations = ( data: ITestDenomination[] ) => {
  return {
      type: actionTypes.TEST_DENOMINATION_ADD_MULTIPLE,
      tests: data
  };
};


export const refreshTestDenominations = ( data: ITestDenomination[] ) => {
  return {
      type: actionTypes.TEST_DENOMINATION_REFRESH,
      tests: data
  };
};

export const reqAdviceTestDenomination = ( data: {id: number, advice_requested_by: number|string, advice_request_date: number} ) => {
  return {
      type: actionTypes.TEST_DENOMINATION_REQ_ADVICE,
      test_id: data.id,
      advice_requested_by: data.advice_requested_by,
      advice_request_date: data.advice_request_date
  };
};

export const reqAdviceCancelTestDenomination = ( data: {id: number, advice_cancelled_by: number|string, advice_cancel_date: number} ) => {
  return {
      type: actionTypes.TEST_DENOMINATION_REQ_ADVICE_CANCEL,
      test_id: data.id,
      advice_cancelled_by: data.advice_cancelled_by,
      advice_cancel_date: data.advice_cancel_date
  };
};
